"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const auth_1 = require("@completeanatomy/auth");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const storage_1 = require("@completeanatomy/storage");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const SubscriptionCard_1 = require("../../molecules/SubscriptionCard/SubscriptionCard");
// eslint-disable-next-line max-lines-per-function
function SubscriptionsSheetPurchase({ onLicenseBuy, onSetSelectedLicense, licenses, isLandscape, isMobile, recommendedLicense, selectedLicense, }) {
    const analytics = (0, analytics_1.useAnalytics)();
    const auth = (0, auth_1.useAuth)();
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const storage = (0, storage_1.useStorageService)();
    const currentUser = (0, user_1.useUser)();
    const { t } = (0, i18n_1.useTranslation)();
    const studentLicense = licenses.studentPlus;
    const proLicense = licenses.pro;
    const handleOnLicenseClick = (license) => {
        const isValidLicense = licenses.studentPlus.product !== undefined;
        if (isValidLicense) {
            selectedLicense === license
                ? onLicenseBuy(license)
                : onSetSelectedLicense(license);
        }
    };
    const onOpenPrivacyPolicy = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: privacyLink });
    };
    const onOpenTerms = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: termsLink });
    };
    const [callRestorePurchase, setCallRestorePurchase] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const getStorageData = () => __awaiter(this, void 0, void 0, function* () {
            const shouldCallRestorePurchase = yield (storage === null || storage === void 0 ? void 0 : storage.get('shouldCallRestorePurchase'));
            if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier) &&
                (callRestorePurchase || shouldCallRestorePurchase === 'true')) {
                storage === null || storage === void 0 ? void 0 : storage.put('shouldCallRestorePurchase', 'false');
                const response = 
                // @ts-ignore
                yield window.Manager.InAppPurchaseManager.restorePurchases();
                setCallRestorePurchase(false);
                if (response === null || response === void 0 ? void 0 : response.success) {
                    storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionSheet', 'false');
                    navigate(`/hub`);
                }
            }
        });
        getStorageData();
    }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier, storage, callRestorePurchase, navigate]);
    const onRestorePurchase = () => __awaiter(this, void 0, void 0, function* () {
        if (!currentUser) {
            auth === null || auth === void 0 ? void 0 : auth.authenticate();
            navigate(`${auth_1.Route.Base}/${auth_1.Route.InterimScreen}/${auth_1.Route.InterimScreenOpen}`, { state: { process: auth_1.AuthProcess.SignIn } });
        }
        analytics.log('PricingRestorePurchasePressed');
        setCallRestorePurchase(true);
        storage === null || storage === void 0 ? void 0 : storage.put('shouldCallRestorePurchase', 'true');
    });
    const bottomText = t(i18n_1.Strings.userOnboarding.subsSheet.buy.description);
    const privacyLink = t(i18n_1.Strings.userOnboarding.subsSheet.buy.privacyLink);
    const termsLink = t(i18n_1.Strings.userOnboarding.subsSheet.buy.termsLink);
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'SubscriptionsSheetPurchase_Container', children: [(0, jsx_runtime_1.jsxs)(ContentContainer, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetPurchase_ContentContainer', children: [(0, jsx_runtime_1.jsx)(SubscriptionCard_1.SubscriptionCard, { license: proLicense, isRecommended: recommendedLicense.type === bridge_schema_1.LicenseType.Pro, isSelected: selectedLicense.type === bridge_schema_1.LicenseType.Pro, onClick: () => handleOnLicenseClick(proLicense), isMobile: isMobile, role: "button", tabIndex: 0, "data-e2e": 'SubscriptionsSheetPurchase_SubscriptionCard' }), (0, jsx_runtime_1.jsx)(SubscriptionCard_1.SubscriptionCard, { license: studentLicense, isRecommended: recommendedLicense.type === bridge_schema_1.LicenseType.StudentPlus, isSelected: selectedLicense.type === bridge_schema_1.LicenseType.StudentPlus, onClick: () => handleOnLicenseClick(studentLicense), isMobile: isMobile, role: "button", tabIndex: 0, "data-e2e": 'SubscriptionsSheetPurchase_SubscriptionCard' })] }), (0, jsx_runtime_1.jsxs)(TextContainer, { "data-e2e": 'SubscriptionsSheetPurchase_TextContainer', children: [(0, jsx_runtime_1.jsx)("div", { "data-e2e": 'SubscriptionsSheetPurchase_div', children: bottomText }), (0, jsx_runtime_1.jsxs)(BottomLinks, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetPurchase_BottomLinks', children: [(0, jsx_runtime_1.jsx)(LinkContainer, { isMobile: isMobile, "data-e2e": 'SubscriptionsSheetPurchase_LinkContainer', children: (0, jsx_runtime_1.jsx)(i18n_1.Trans, { i18nKey: "userOnboarding.subsSheet.buy.agreements", components: {
                                        1: ((0, jsx_runtime_1.jsx)(StyledLink, { tabIndex: 0, onKeyDown: e => {
                                                if (e.key === 'Enter')
                                                    onOpenPrivacyPolicy();
                                            }, onClick: () => onOpenPrivacyPolicy() })),
                                        3: ((0, jsx_runtime_1.jsx)(StyledLink, { tabIndex: 0, onKeyDown: e => {
                                                if (e.key === 'Enter')
                                                    onOpenTerms();
                                            }, onClick: () => onOpenTerms() })),
                                    }, "data-e2e": 'SubscriptionsSheetPurchase_Trans' }) }), (0, jsx_runtime_1.jsx)(LinkContainer, { isMobile: isMobile, "data-e2e": 'SubscriptionsSheetPurchase_LinkContainer', children: (0, jsx_runtime_1.jsx)(i18n_1.Trans, { i18nKey: "userOnboarding.subsSheet.buy.restore", components: {
                                        1: ((0, jsx_runtime_1.jsx)(StyledLink, { tabIndex: 0, onKeyDown: e => {
                                                if (e.key === 'Enter')
                                                    onRestorePurchase();
                                            }, onClick: () => onRestorePurchase() })),
                                    }, "data-e2e": 'SubscriptionsSheetPurchase_Trans' }) })] })] })] }));
}
exports.default = (0, storage_1.withStorageProvider)(SubscriptionsSheetPurchase);
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 20px;
`;
const ContentContainer = styled_components_1.default.div `
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;

  gap: 20px;
  margin-top: 1em;

  ${({ isMobile, isLandscape }) => isMobile &&
    !isLandscape &&
    `
      flex-wrap: wrap;
      flex-direction: column;
      align-content: center;
  `};
`;
const TextContainer = styled_components_1.default.div `
  font-size: 14px;
  color: white;
  text-align: center;
  padding: 1em 0;

  background: linear-gradient(to right, transparent, #11151c 4%, transparent),
    linear-gradient(to left, transparent, #11151c 4%, transparent);
`;
const BottomLinks = styled_components_1.default.div `
  margin-top: 1em;
  margin-bottom: 1em;
  color: #a2a7aa;
  display: flex;

  flex-direction: row;
  align-items: center;

  ${({ isMobile, isLandscape }) => isMobile &&
    !isLandscape &&
    `
      flex-direction: column;
      gap: 10px;
      justify-self: center;
  `};
`;
const LinkContainer = styled_components_1.default.div `
  padding: 0 1.8em;

  ${({ isMobile }) => isMobile && `margin: 0 2em;`};
`;
const StyledLink = styled_components_1.default.a `
  color: #a2a7aa;
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid #47cfcb;
    outline-offset: 2px;
  }
`;
